import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import useExtendedState from '../../hooks/useExtendedState';
import SaveButton from '../buttons/SaveButton';
import TextField from '../fields/TextField';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import {
    COUNTRY_CODE_MAX_LENGTH,
    COUNTRY_NAME_MAX_LENGTH,
    countryCodeValidator,
    countryNameValidator,
} from '../../validators/countries';
import useMultiValidator from '../../hooks/useMultiValidator';
import { ALL_COUNTRIES_QUERY_NAME, CREATE_COUNTRY } from '../../graphql/countries';
import ExpandedListTab from '../ExpandedListTab';
import { compositeValidator, wafValidator } from '../../hooks/validationSupport';

CountryCreateTab.propTypes = {
    hideHandler: PropTypes.func.isRequired,
};

function CountryCreateTab(props) {
    const { hideHandler } = props;
    const { t } = useTranslation();
    const nameState = useExtendedState('');
    const codeState = useExtendedState('');
    const { validators, isValid } = useMultiValidator(false, {
        name: compositeValidator(countryNameValidator(t), wafValidator(t)),
        code: compositeValidator(countryCodeValidator(t), wafValidator(t)),
    });
    const [isDisabled, setIsDisabled] = useState(true);
    isValid()
        .then(() => setIsDisabled(false))
        .catch(() => setIsDisabled(true));

    const extendedMutation = useExtendedMutation(CREATE_COUNTRY, {
        variables: {
            code: codeState.value,
            name: nameState.value,
        },
        successCallback: hideHandler,
        successMessageOptions: { key: 'countries.notification.country-create-success', dataProperty: 'createCountry' },
        failureMessageOptions: { key: 'countries.notification.country-create-failure', params: { name: nameState.value, code: codeState.value } },
        refetchQueries: [ALL_COUNTRIES_QUERY_NAME],
    });
    return (
        <ExpandedListTab
            className="country-create-tab"
            title={t('countries.country-detail')}
        >
            <div className="rich-list-row-expanded--fields">
                <TextField
                    label={t('countries.name')}
                    state={nameState}
                    className="country-create-tab--fields--name wide"
                    validator={validators.name}
                    placeholder={t('countries.placeholder.name')}
                    maxLength={COUNTRY_NAME_MAX_LENGTH}
                    isRequired
                />
                <TextField
                    label={t('countries.code')}
                    state={codeState}
                    className="country-create-tab--fields--code"
                    validator={validators.code}
                    placeholder={t('countries.placeholder.code')}
                    maxLength={COUNTRY_CODE_MAX_LENGTH}
                    isRequired
                />
            </div>
            <div className="rich-list-row-expanded--buttons">
                <SaveButton extendedMutation={extendedMutation} disabled={isDisabled} confirmationMessage={t('countries.confirm-create-country', { name: nameState.value, code: codeState.value })} />
            </div>
        </ExpandedListTab>
    );
}

export default CountryCreateTab;
